$(function () {

  // // hamburger menu
  // $(".hamburger-menu").on("click", function () {
  //     $(".cwr-main-header__col nav").slideToggle();
  // });
  // if($(window).width() < 1200){
  //   $(".cwr-main-header__col nav .sub-menu .mobile-svg").on("click", function () {
  //       if ($(".cwr-main-header__col nav").css("display") === "block") {
  //           $(".sub-menu__inner").slideToggle();
  //           $(this).toggleClass("open-menu");
  //       }
  //   });
  // }
  // end hamburger menu

  // usp slider
  let uspSlider = {   
      speed: 7000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: true,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false,
      mobileFirst: true,
      lazyLoad: 'ondemand',
      responsive: [
          {
              breakpoint: 992,
              settings: 'unslick'
          },
      ]
  }
  var winUspSlider = $(window);
  var sliderUspSlider = $(".js-usp-main-slider");

  winUspSlider.on("load resize", function () {
      if (winUspSlider.width() < 992) {
          sliderUspSlider.not(".slick-initialized").slick(uspSlider);
      } else if (sliderUspSlider.hasClass("slick-initialized")) {
          sliderUspSlider.slick("unslick");
      }
  });
  // end usp slider

  // matchHeight
  if($('.our-best-sellers__slider-item-box .desc h3').length > 0){
    $('.our-best-sellers__slider-item-box .desc h3').matchHeight({
        byRow: 0,
    });
  }
  if($('.shop-by-solution__item-box p').length > 0){
    $('.shop-by-solution__item-box p').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__heading-item .col1').length > 0){
    $('.compare-diffrence__heading-item .col1').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col2').length > 0){
    $('.compare-diffrence__item .col2').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col3').length > 0){
    $('.compare-diffrence__item .col3').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col4').length > 0){
    $('.compare-diffrence__item .col4').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col5').length > 0){
    $('.compare-diffrence__item .col5').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col6').length > 0){
    $('.compare-diffrence__item .col6').matchHeight({
        byRow: 0,
    });
  }
  if($('.compare-diffrence__item .col7').length > 0){
    $('.compare-diffrence__item .col7').matchHeight({
        byRow: 0,
    });
  }
  // end matchHeight

  // Shop by Solution slider
  let shopBySlider = {   
      dots: false,
      infinite: true,       
      slidesToShow: 5,
      slidesToScroll: 1,
      initialSlide: 2,
      autoplay: true,
      arrows: false,
      centerMode: true,
      lazyLoad: 'ondemand',
      centerPadding: '0px',
      responsive: [
          {
              breakpoint: 1200,
              settings: {
                slidesToShow: 4,
              }
          },
      ]
  }
  var winShopBySliderSlider = $(window);
  var sliderShopBy = $(".js-shop-by-solution-slider");

  winShopBySliderSlider.on("load resize", function () {
      if (winShopBySliderSlider.width() >= 992) {
          sliderShopBy.not(".slick-initialized").slick(shopBySlider);
      } else if (sliderShopBy.hasClass("slick-initialized")) {
          sliderShopBy.slick("unslick");
      }
  });
  // end Shop by Solution slider

  // you can find us
  if ($(".js-you-can-find-us-slider").length > 0) {
    $(".js-you-can-find-us-slider").slick({
      dots: false,
      arrows: false,
      infinite: true,
      lazyLoad: "ondemand",
      autoplay: true,
      autoplaySpeed: 2000,
      variableWidth: true,
      slidesToScroll: 1,
    });
  }
  // end you can find us

  // our our reputation slider
  if ($(".js-our-reputation-slider").length > 0) {
    $(".js-our-reputation-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      centerMode: false,
      arrows: true,
      dots: true,
      lazyLoad: 'ondemand',
      prevArrow: $(".js-our-reputation-prev"),
      nextArrow: $(".js-our-reputation-next"),
      appendDots: $('.js-our-reputation-dot'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '130px',
          },
        },
        {
          breakpoint: 821,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '130px',
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '80px',
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: '0px',
          },
        },
      ],
    });
}      
// end our reputation slider

// feature marquee
if ($(".js-feature-marquee").length > 0){
  $('.js-feature-marquee').slick({
    speed: 3000,
    autoplay: true,
    autoplaySpeed: 100,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 0,
    arrows: false,
    buttons: false
  });
}
// end feature marquee

// as seen on clients
if ($(".js-as-seen-on-clients").length > 0) {
  $(".js-as-seen-on-clients").slick({
    dots: false,
    arrows: false,
    infinite: true,
    lazyLoad: "progressive",
    autoplay: true,
    autoplaySpeed: 2000,
    variableWidth: true,
    slidesToScroll: 1,
  });
}
// end as seen on clients

// accordian 
var action="click";
var speed="500";

$('.faq__item-question').on(action, function() {
    $(this).parent().siblings().find('.faq__item-answer').slideUp();
    $(this).parent().siblings().removeClass('active');
    $(this).parent().toggleClass('active');
    $(this).next().slideToggle(speed);
});
// end accordian

// insta in heading icon
let headingIcon = `<img class="img-fluid" src="//www.petsmont.com/cdn/shop/files/cwr-pet-icon.png?v=1729070552" alt="icon" width="32" height="32">`;
$(headingIcon).insertBefore(".cwr-instafeed--new .cwr-instafeed__inner .ooo-instagram-header h2");
});


setTimeout(() => {
// New Carousel Slider
  if ($(".js-cwr-carousel-slider").length > 0) {
    console.log('slider inner');
    $(".js-cwr-carousel-slider").slick({
      dots: false,
      arrows: true,
      infinite: true,
      lazyLoad: "ondemand",
      autoplay: true,
      autoplaySpeed: 4000,
      variableWidth: true,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '120px'
    });

    $(".js-cwr-carousel-slider").addClass("no-left-padding"); // Add a class to override left padding only on first load
    $(".js-cwr-carousel-slider").addClass("no-left-padding");

    // On first swipe, remove the override class
    $(".js-cwr-carousel-slider").on("afterChange", function () {
      $(this).removeClass("no-left-padding");
    });
    
    $(window).on('load', function () {
      const $slider = $('.js-cwr-carousel-slider');

      // Hide previous slide of .slick-center
      const $center = $slider.find('.slick-center');
      $center.prev().addClass('hide-on-load');

      $slider.on('afterChange', function () {
        $slider.find('.hide-on-load').removeClass('hide-on-load');
      });
    });
  }
}, 500);
  

  
    // PDP Marquee slider
  if ($(".js-pdp-marquee").length > 0) {
      $('.js-pdp-marquee').slick({
      speed: 2000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: false,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      focusOnSelect:false,
      pauseOnFocus:false,
      pauseOnHover:false,
      infinite: true,
      initialSlide: 1,
      arrows: false,
      buttons: false
    });
  }      
  // End PDP Marquee slider

  document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".pdp__product-slider");
    if (!slider) return;
    const swiper = new Swiper(".pdp__product-slider", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      speed: 500,
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
      },
      watchOverflow: true,
      observer: true,
      observeParents: true,
      resistanceRatio: 0.85,
      navigation: {
        nextEl: ".custom-next",
        prevEl: ".custom-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      touchRatio: 1,
      touchAngle: 45,
      grabCursor: true,
      simulateTouch: true,
      followFinger: true,
      threshold: 5,
      keyboard: {
        enabled: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1024: {
          slidesPerView: 1,
        },
      },
    });
  });
  const $ReviewSlider = $('.js-pdp-review-slider');
  if ($ReviewSlider.children().length > 1) {
    if (!$ReviewSlider.hasClass('slick-initialized')) {
      $ReviewSlider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        lazyLoad: "ondemand",
        autoplay: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true
      });
    }
  } else {
    if ($ReviewSlider.hasClass('slick-initialized')) {
      $ReviewSlider.slick('unslick');
    }
  }

document.querySelectorAll('.cwr-pdp-hero .accordion-header').forEach(header => {
  header.addEventListener('click', () => {

    const parent = header.closest('.accordion-item');
    const allItems = document.querySelectorAll('.cwr-pdp-hero .accordion-item');

    // Close all except the clicked one
    allItems.forEach(item => {
      if (item !== parent) {
        item.classList.remove('active');
      }
    });

    // Toggle clicked one
    parent.classList.toggle('active');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(".pdp-quantity-tabs .tab-btn");
  const tabContents = document.querySelectorAll(".pdp-quantity-tabs .pdp-quantity__products");

  tabButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const target = this.getAttribute("data-tab");

      // remove active from all buttons
      tabButtons.forEach((b) => b.classList.remove("active"));

      // remove active from all content
      tabContents.forEach((c) => c.classList.remove("active"));

      // add active to clicked tab + related content
      this.classList.add("active");
      document.getElementById(target).classList.add("active");
    });
  });
});
